const blockColors = {
    motion: {
        colourPrimary: '#0F1E33',
        colourSecondary: '#4C4C4C',
        colourTertiary: '#4C97FF',
        colorQuaternary: '#4C97FF'
    },
    looks: {
        colourPrimary: '#1E1433',
        colourSecondary: '#4C4C4C',
        colourTertiary: '#9966FF',
        colorQuaternary: '#9966FF'
    },
    sounds: {
        colourPrimary: '#291329',
        colourSecondary: '#4C4C4C',
        colourTertiary: '#CF63CF',
        colorQuaternary: '#CF63CF'
    },
    control: {
        colourPrimary: '#332205',
        colourSecondary: '#4C4C4C',
        colourTertiary: '#FFAB19',
        colorQuaternary: '#FFAB19'
    },
    event: {
        colourPrimary: '#332600',
        colourSecondary: '#4C4C4C',
        colourTertiary: '#FFBF00',
        colorQuaternary: '#FFBF00'
    },
    sensing: {
        colourPrimary: '#12232A',
        colourSecondary: '#4C4C4C',
        colourTertiary: '#5CB1D6',
        colorQuaternary: '#5CB1D6'
    },
    pen: {
        colourPrimary: '#03251C',
        colourSecondary: '#4C4C4C',
        colourTertiary: '#0fBD8C',
        colorQuaternary: '#0fBD8C'
    },
    operators: {
        colourPrimary: '#112611',
        colourSecondary: '#4C4C4C',
        colourTertiary: '#59C059',
        colorQuaternary: '#59C059'
    },
    data: {
        colourPrimary: '#331C05',
        colourSecondary: '#4C4C4C',
        colourTertiary: '#FF8C1A',
        colorQuaternary: '#FF8C1A'
    },
    data_lists: {
        colourPrimary: '#331405',
        colourSecondary: '#4C4C4C',
        colourTertiary: '#FF661A',
        colorQuaternary: '#FF661A'
    },
    more: {
        colourPrimary: '#331419',
        colourSecondary: '#4C4C4C',
        colourTertiary: '#FF6680',
        colorQuaternary: '#FF6680'
    },
    text: 'rgba(255, 255, 255, .7)',
    textFieldText: '#E5E5E5',
    workspace: '#121212',
    toolboxSelected: '#4C4C4C',
    toolboxText: '#E5E5E5',
    toolbox: '#121212',
    flyout: '#121212',
    textField: '#4C4C4C',
    menuHover: 'rgba(255, 255, 255, 0.3)'
};

const extensions = {};

export {
    blockColors,
    extensions
};
